module.exports = __webpack_public_path__ + "img/recordar.4f6fab25.svg";